import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { InventoryCategory } from '../services/inventoryCategoriesService';
import { ModernInventoryCategoryList } from './ModernInventoryCategoryList';
import { ModernInventoryCategoryForm } from './ModernInventoryCategoryForm';

export const ModernInventoryCategoryManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState<InventoryCategory | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingCategory(null);
    setFormOpen(true);
  };

  const handleEditClick = (category: InventoryCategory) => {
    setEditingCategory(category);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingCategory(null);
  };

  const handleFormSave = async (category: InventoryCategory) => {
    console.log('✅ handleFormSave called, closing dialog first');
    setFormOpen(false);
    setEditingCategory(null);
    
    // Trigger refresh of the category list after a delay to ensure API call completes
    setTimeout(() => {
      setRefreshKey((prev) => {
        console.log(`✅ refreshKey changed from ${prev} to ${prev + 1}`);
        return prev + 1;
      });
    }, 1000);
  };

  return (
    <div className="container mx-auto p-6" data-testid="inventory-category-management">
      <ModernInventoryCategoryList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernInventoryCategoryForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        category={editingCategory}
      />
    </div>
  );
};

